import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import view from "../../Assets/Image/admin/view.png";
import deletes from "../../Assets/Image/admin/delete.png";
import add from "../../Assets/Image/admin/add.png";
import { useNavigate } from "react-router-dom";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { CircleX } from "lucide-react";
import edit from "../../Assets/Image/admin/edit.png";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { IMG_URL } from "../../Services/Api";
import noImage from "../../Assets/Image/admin/user.png";
import {
  addSocialLink,
  deleteSocialLink,
  getCategoryList,
  getSocialLink,
  updatedSocialLink,
} from "../../Services/ApiServices";
import "suneditor/dist/css/suneditor.min.css";

function SocialLink() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [isAddWeblink, setIsAddWeblink] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const [storeId, setStoreId] = useState("");
  const [isIndex, setIsIndex] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [formValue, setFormValue] = useState({});

  const [socialLinkData, setSocialLinkData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  const handleCategoryList = () => {
    setLoader(true);
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setCategoryData(data);
        const option = data?.map((item) => ({
          label: (
            <div className="flex items-center p-1 uppercase">
              <img
                src={
                  item.category_image ? IMG_URL + item.category_image : noImage
                }
                className="w-14 h-14 rounded-md object-cover mr-2"
              />
              {item.category_name || ""}
            </div>
          ),
          value: item.id,
          id: item.category_name,
        }));

        if (option?.length > 0) {
          setSelectedOption(option[0]);
        }
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  const handleSocialLink = (data) => {
    setLoader(true);
    let obj = {
      category_id: data,
    };
    getSocialLink(obj)
      .then((res) => {
        const data = res.data.data;
        setSocialLinkData(data);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleCategoryList();
  }, []);

  useEffect(() => {
    if (selectedOption) {
      handleSocialLink(selectedOption.value);
    }
  }, [selectedOption, pageNo]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      height: "50px",
      border: "none",
      outline: "0px",
      boxShadow: "none",
      "&:hover": {
        border: "none",
      },
      "&:focus": {
        border: "none",
        boxShadow: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px",
      padding: "0 8px",
      border: "0px",
      outline: "0px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "50px",
      border: "0px",
      outline: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      backgroundColor: state.isSelected
        ? "#e29c2995"
        : state.isFocused
        ? "#e29c2940"
        : "white",
      ":active": {
        backgroundColor: "#e29c2910",
        color: "white",
      },
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return {
        ...provided,
        opacity,
        transition,
        display: "flex",
        alignItems: "center",
      };
    },
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isUpdate) {
      let obj = {
        link: formValue.link,
        category_id: formValue.category_id,
        social_name: formValue.social_name,
        social_link_id: formValue.id,
      };
      updatedSocialLink(obj)
        .then((res) => {
          toast.success(res.data.message);
          setIsAddWeblink(false);
          handleSocialLink(selectedOption.value);
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err?.response?.data?.message);
          }
          setIsLoading(false);
        });
    } else {
      let obj = {
        link: formValue.link,
        category_id: formValue.category_id,
        social_name: formValue.social_name,
      };

      addSocialLink(obj)
        .then((res) => {
          toast.success(res.data.message);
          setIsAddWeblink(false);
          handleSocialLink(selectedOption.value);
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err?.response?.data?.message);
          }
          setIsLoading(false);
        });
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      social_link_id: storeId,
    };
    deleteSocialLink(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...socialLinkData];
        data.splice(isIndex, 1);
        setSocialLinkData(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else if (err?.response?.status == 422) {
          const errs = err?.response?.data;
          toast.error(errs?.errors[0]?.msg);
        } else {
          toast.error(err?.response?.data?.message);
        }
        setIsLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    setFormValue(data);
    setIsAddWeblink(true);
    setIsLoading(false);
  };

  const handleView = () => {
    setIsAddWeblink(true);
    setFormValue({});
    setIsLoading(false);
    setIsUpdate(false);
  };

  const handleDeleteView = (id, index) => {
    setIsDelete(true);
    setStoreId(id);
    setIsIndex(index);
    setIsLoading(false);
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="sm:w-auto w-full">
          <div>
            <button
              onClick={handleView}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Social Link
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mb-5">
        <div className="lg:col-span-6 col-span-12">
          <Select
            value={selectedOption}
            onChange={(option) => {
              setSelectedOption(option);
              setPageNo(1);
            }}
            options={categoryData?.map((item) => ({
              label: (
                <div className="flex items-center p-1 uppercase">
                  <img
                    src={
                      item.category_image
                        ? IMG_URL + item.category_image
                        : noImage
                    }
                    className="w-14 h-14 rounded-md object-cover mr-2"
                  />
                  {item.category_name || ""}
                </div>
              ),
              value: item.id,
              id: item.category_name,
            }))}
            placeholder="Select Category"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
      </div>

      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {socialLinkData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <div className="col-span-12">
                <div
                  className="w-full lg:overflow-hidden overflow-auto"
                  onMouseDown={startDragging}
                  onMouseLeave={stopDragging}
                  onMouseUp={stopDragging}
                  onMouseMove={onDragging}
                  ref={scrollRef}
                >
                  <table className="w-full border-separate border-spacing-y-3">
                    <thead>
                      <tr className="bg-white">
                        <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>Social Media ID</h4>
                        </th>
                        <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>Social Media Name</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>Social Media URL</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <div className="text-center">
                            <h4>ACTION</h4>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {socialLinkData.map((item, index) => (
                        <tr key={index} className="font-medium bg-white">
                          <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              {item.id || "-"}
                            </div>
                          </td>
                          <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              {item.social_name || "-"}
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <p className="text-base truncate w-[400px] text-blue-700">
                                <a href={item.link} target="_blank">
                                  {item.link || ""}
                                </a>
                              </p>
                            </div>
                          </td>
                          <td className="text-start flex justify-center lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="flex items-center w-52 justify-center">
                              <div
                                onClick={(e) => {
                                  setModalOpens(true);
                                  setFormValue(item);
                                  setIsLoading(false);
                                }}
                                className="cursor-pointer"
                              >
                                <img
                                  src={view}
                                  className="lg:w-9 w-8"
                                  alt="View"
                                />
                              </div>
                              <div
                                onClick={(e) =>
                                  handleDeleteView(item.id, index)
                                }
                                className="ml-4 cursor-pointer"
                              >
                                <img
                                  src={deletes}
                                  className="lg:w-9 w-8"
                                  alt="Delete"
                                />
                              </div>
                              <div
                                className="ml-4 cursor-pointer"
                                onClick={() => handleEdit(item)}
                              >
                                <img
                                  src={edit}
                                  className="lg:w-9 w-8"
                                  alt="Delete"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <Dialog
        open={isAddWeblink}
        onClose={() => setIsAddWeblink(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} Social Link
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">
                      Select Category
                    </h4>
                    <select
                      name="category_id"
                      required
                      value={formValue.category_id || ""}
                      onChange={handleChange}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Category"></option>
                      {categoryData.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.category_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Social Media Name
                    </h4>
                    <select
                      name="social_name"
                      required
                      value={formValue.social_name || ""}
                      onChange={handleChange}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Category"></option>
                      <option value="youtube">Youtube</option>
                      <option value="facebook">Facebook</option>
                      <option value="instagram">Instagram</option>
                      <option value="linkedin">Linkedin</option>
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Social Media URL
                    </h4>
                    <input
                      type="url"
                      name="link"
                      required
                      value={formValue.link || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddWeblink(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:w-auto w-[330px] max-h-[500px] overflow-auto fontNew">
              <div className="flex justify-between border-b p-5">
                <h4 className="text-lg font-medium">Social Media Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setModalOpens(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="p-5">
                <div>
                  <p>Social Media Name :</p>
                  <h3 className="text-lg font-medium break-words">
                    {formValue.social_name || ""}
                  </h3>
                </div>
                <div className="mt-3">
                  <p>Social Media URL :</p>
                  <h3 className="text-lg font-medium break-words text-blue-600">
                    <a href={formValue.link} target="_blank">
                      {formValue.link || ""}
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Social Link?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Social Link?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default SocialLink;
